import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { runRecognizeOrders } from "./run-recognize-orders";

export const runRecognizeReturners = unaryRpc({
  name: "runRecognizeReturners",
  input: z.object({
    teamId: zExt.objectId(),
    targetCount: z.number().int().min(1).max(10_000),
  }),
  output: runRecognizeOrders.output,
});
